import React from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import omitBy from "lodash.omitby";
import isNull from "lodash.isnull";
import CloudFlyerAPI from "../../../api/CloudFlyerAPI";
import SaveButton from "../../../components/Shared/SaveButton";
import BackLink from "../../../components/Shared/BackLink";
import BorderlessInput from "../../../components/Shared/BorderlessInput";
import { update_user } from "../../../actions/auth";
import "./index.scss";

class AddCreditCard extends React.Component {
  constructor(props) {
    super();
    const { user } = props;
    this.state = {
      loading: false,
      creditCard: {
        name: "",
        billing_city: "",
        billing_address: "",
        billing_zip: "",
        billing_country: "",
        card_number: "",
        expiration_date: "",
        ccv: ""
      },
      edit: props.match.params.subscriptionId
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentDidMount() {
    const { getSubscription, getPaymentsHistory } = CloudFlyerAPI.billing;
    const { match } = this.props;
    const { subscriptionId } = match.params;
    if (!subscriptionId) return;
    getSubscription(match.params.subscriptionId).then(({ data }) => {
      const { subscription } = data;
      const { credit_card } = subscription;
      const creditCard = {
        ...omitBy(credit_card, isNull),
        name: credit_card.first_name + credit_card.last_name,
        expiration_date:
          credit_card.expiration_month +
          "/" +
          String(credit_card.expiration_year).substr(-2),
        card_number: credit_card.masked_card_number
      };
      this.setState({
        creditCard
      });
    });
  }

  handleChange({ target }) {
    this.setState({
      creditCard: {
        ...this.state.creditCard,
        [target.name]: target.value
      }
    });
  }

  handleSubmit(e) {
    e.preventDefault();
    const { form } = this.state;
    const { dispatch } = this.props;
    this.setState({ loading: true });
    dispatch(update_user(form));
  }

  render() {
    const { creditCard, edit, loading } = this.state;
    return (
      <div className="add-card-container">
        {/* <BackLink to='/billing' text='Go back to payments details' /> */}
        <div className="add-card">
          {/* <h3>{edit ? "Edit" : "Add"} Credit Card</h3> */}
          <form method="post" onSubmit={this.handleSubmit}>
            <div className="user-info">
              <BorderlessInput
                value={creditCard.name}
                name="name"
                onChange={this.handleChange}
                label="Your name"
                required
              />
              <BorderlessInput
                value={creditCard.billing_city}
                name="billing_city"
                onChange={this.handleChange}
                label="Billing City"
                required
              />
              <BorderlessInput
                value={creditCard.billing_address}
                name="billing_address"
                className="billing_address"
                onChange={this.handleChange}
                label="Billing Address"
                required
              />
              <BorderlessInput
                value={creditCard.billing_zip}
                name="billing_zip"
                className="billing_zip"
                onChange={this.handleChange}
                label="Postal Code"
                required
              />
              <BorderlessInput
                value={creditCard.billing_country}
                name="billing_country"
                className="billing_country"
                onChange={this.handleChange}
                label="Billing Country"
                required
              />
            </div>
            <h5>Credit Card Details</h5>
            <div className="card-info">
              <BorderlessInput
                value={creditCard.card_number}
                name="card_number"
                className="card_number"
                onChange={this.handleChange}
                label="Card Number"
                required
              />
              <BorderlessInput
                value={creditCard.expiration_date}
                name="expiration_date"
                className="small"
                onChange={this.handleChange}
                label="MM/YY"
                required
              />
              <BorderlessInput
                value={creditCard.ccv}
                name="ccv"
                className="small"
                onChange={this.handleChange}
                label="CCV"
                required
              />
            </div>
            <div className="save-button-container">
              <SaveButton type="submit">
                Save {!edit && "and Enable"} card
              </SaveButton>
            </div>
          </form>
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ auth }) => ({ user: auth.user });

export default withRouter(connect(mapStateToProps)(AddCreditCard));
